<template>
  <div class="__close_button" @click="close()">
    <font-awesome-icon :icon="['fas', 'times']" />
  </div>
</template>

<script>
export default {
  name: "CloseButton",
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../theme.scss";

.__close_button {
  width: 56px;
  height: 56px;
  background-color: #f5f5f5;
  color: #a5a5a5;
  cursor: pointer;
  line-height: 56px;
  text-align: center;
  font-size: 28px;
  border-radius: 100%;

  &:hover {
    background-color: #e5e5e5;
    color: white;
  }
}
</style>
